// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {
  BootstrapVue,
  IconsPlugin,
  BLink
} from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import QS from 'qs'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/bootstrap.min.css'
import '@/assets/css/kidz.css'
import '@/assets/style.css'

import api from './api/index.js'

// Install BootstrapVue
Vue.use(BootstrapVue, BLink)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.prototype.$http = axios

Vue.use(VueAxios, axios, QS)
Vue.config.productionTip = false

Vue.config.$api = api.root
Vue.config.$aws = api.aws

axios.defaults.headers.post['Content-Type'] = 'application/json' // 切换环境js

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js